
    import {Inject, Options, Vue} from 'vue-property-decorator';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {ProfileCompletionRepositoryAPI} from '@/profile-creation-wizard/components/for-completion/infra/repository/ProfileCompletionRepositoryAPI';
    import StepActions from '@/profile-creation-wizard/common/ui/step/StepActions.vue';
    import StepMobileHeader from '@/profile-creation-wizard/common/ui/step/StepMobileHeader.vue';
    import {SeniorityLevel} from '@/profile-creation-wizard/components/for-completion/domain/types';
    import SeniorityLevelSelection from '@/profile-creation-wizard/components/for-completion/ui/7_privacy/SeniorityLevelSelection.vue';
    import {TrackingRepository} from '@/common/repositories/track/TrackingRepository';
    import {StepNavigator} from '@/profile-creation-wizard/common/step/StepNavigator';

    @Options({
        components: {
            StepActions,
            StepMobileHeader,
            SeniorityLevelSelection,
        },
    })
    export default class PrivacyStep extends Vue {
        progressPercentage = 0;
        previousStepName?: string;

        @Inject({from: DI.profileCompletionRepository})
        profileCompletionRepository!: ProfileCompletionRepositoryAPI;
        @Inject({from: DI.trackingRepository})
        trackingRepository!: TrackingRepository;

        hasError = false;
        seniorityLevelSelection: SeniorityLevel | null = null;
        indexable = true;
        showMoreEnabled = false;

        stepName = 'privacy';
        isLoadingButtonFinish = false;

        created(): void {
            this.trackingRepository.track('privacy-view-page-v2');
            const meta = this.$router.currentRoute.value.meta;

            this.progressPercentage = meta.progressPercentage || 0;
            this.stepNavigator = new StepNavigator(this.$router, meta.previousStep, undefined);
        }

        get hasValidFieldPart(): boolean {
            return this.seniorityLevelSelection != null;
        }

        selectSeniorityLevel(seniorityLevel: string): void {
            this.seniorityLevelSelection = SeniorityLevel[seniorityLevel];
        }

        unselectSeniorityLevel(): void {
            this.seniorityLevelSelection = null;
        }

        handleChangeIndexable(changeIndexableEvent: CustomEvent) {
            this.indexable = changeIndexableEvent.detail;
        }

        async goNext(): Promise<void> {
            this.isLoadingButtonFinish = true;
            if (this.seniorityLevelSelection) {
                await this.saveSeniorityLevelSelection(this.seniorityLevelSelection);
            }

            if (!this.indexable) {
                await this.profileCompletionRepository.updateProfilePreference(false);
            }

            await this.trackingRepository.track('completion-ended-v2');

            location.href = `/profile${this.$features.profileOnboardingDialog ? '?firstTour=true' : ''}`;
        }

        async saveSeniorityLevelSelection(seniorityLevelSelection: SeniorityLevel): Promise<void> {
            await this.profileCompletionRepository.updateSeniorityLevel(seniorityLevelSelection);
        }

        toggleShowMoreIndexable(): void {
            this.showMoreEnabled = !this.showMoreEnabled;
        }

        get toggleShowMoreText(): string {
            return this.showMoreEnabled ? this.$msg('generic.show.less') : this.$msg('generic.show.more');
        }

        goToPrevious(): void {
            this.stepNavigator.previous();
        }
    }
